var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('flowy-drag-handle',[_c('v-btn',{attrs:{"color":"grey","icon":""}},[_c('v-icon',[_vm._v("mdi-account")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }